import useSnackbarSystem from '@ui/systems/useSnackbarSystem';

import './ScimEnterprisePaywall.scss';

const SALES_EMAIL = 'enterprise@verybusy.io';

const ScimEnterprisePaywall = () => {
	const snackbarSystem = useSnackbarSystem();

	const handleCopyEmail = async () => {
		await navigator.clipboard.writeText( SALES_EMAIL );
		snackbarSystem.showCopiedToClipboardMessage( 'Email copied to clipboard' );
	};

	return (
		<div className="ScimEnterprisePaywall">
			<div className="ScimEnterprisePaywall-header">
				<div className="ScimEnterprisePaywall-title-row">
					<span className="ScimEnterprisePaywall-title">SCIM Provisioning</span>
					<span className="ScimEnterprisePaywall-badge">Enterprise Only</span>
				</div>
				<p className="ScimEnterprisePaywall-description">
					Connect your identity provider to automatically manage VeryBusy accounts when employees join,
					change roles, or leave. Copy your SCIM key and endpoint to your identity provider.{' '}
					{/* Temporal: "Coming soon!" en lugar de "How to set up SCIM →" */}
					{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
					<a className="ScimEnterprisePaywall-link" href="#">Coming soon!</a>
				</p>
			</div>

			<div className="ScimEnterprisePaywall-actions">
				<p className="ScimEnterprisePaywall-contact">
					Contact Sales at{' '}
					<button
						type="button"
						className="ScimEnterprisePaywall-contact-email"
						onClick={handleCopyEmail}
					>
						{SALES_EMAIL}
					</button>
				</p>
			</div>
		</div>
	);
};

export default ScimEnterprisePaywall;
